export default {"src":"/_next/static/media/logo-grey-small.4e4d336c.svg","height":40,"width":33,"blurWidth":0,"blurHeight":0};